import React, { useEffect, useState } from "react";
import Modal from "../elements/Modal";
import ImageUploader from "../form/ImageUploader";
import useForm from "../../hooks/useForm";
import Input from "../form/Input";
import { formValidate } from "../../helpers/formValidate";
import PhoneNumberFormat from "../form/PhoneNumberFormat";
import Button from "../form/Button";
import Tooltip from "../elements/Tooltip";
import { toast } from "react-toastify";
import { profileUpdate } from "../../services/ProfileService";
import useMutation from "../../hooks/useMutation";
import { useDispatch } from "react-redux";
import { setProfile } from "../../redux/slice/profileSlice";
import { useSelector } from "react-redux";

function ProfileComponent({ image, setImage = () => {} }) {
  const dispatch = useDispatch();
  const user = useSelector((state) => state?.profile?.data);
  const [phone, setPhone] = useState("");

  const validation = {
    firstName: { required: true, message: "Please enter your first name!" },
    lastName: { required: true, message: "Please enter your last name!" },
  };
  const { values, handleChange, handleSubmit, errors, setFieldsValue } =
    useForm({ validationRules: validation });

  useEffect(() => {
    if (user) {
      setFieldsValue({
        firstName: user?.firstName || "",
        lastName: user?.lastName || "",
        email: user?.email || "",
        dateOfBirth: user?.dateOfBirth || "",
        address: user?.address?.address1 || "",
      });
      setPhone(user?.phone || "");
      setImage(user?.image?.url || "");
    }
  }, [user]);

  const {
    mutate,
    error: signUpError,
    isPending: profileLoding,
    // data: signUpData,
  } = useMutation({
    mutationFn: async (val) => {
      return await profileUpdate({
        firstName: val?.firstName,
        lastName: val?.lastName,
        phone: phone || "",
        image: image || "null",
        "address[address1]": values.address,
        dateOfBirth: values.dateOfBirth,
      });
    },
    onSuccess: async (res) => {
      if (res?.status === 200 || res?.status === 201) {
        toast.success(res?.message || res?.data?.message);
        dispatch(setProfile({ ...user, ...(res?.data || {}) }));
      } else {
        toast?.error(
          res?.data?.message || res?.error || "Something went wrong"
        );
      }
    },
  });

  return (
    <div className="grid grid-cols-12 gap-6 py-6 xls:pr-10">
      {/* Profile Info Form Section */}
      <div className="col-span-12 flex flex-col">
        <form onSubmit={(e) => handleSubmit(e, mutate)} className="space-y-6">
          <div className="grid md:grid-cols-2 gap-6">
            <div>
              <Input
                label={"First Name"}
                inputType={"text"}
                value={values?.firstName || ""}
                inputPlaceholder={"Enter first name"}
                inputName="firstName"
                onChange={handleChange}
                isValidate={true}
                required={true}
                charLimit={20}
                inputClasses={"!h-11 md:!h-11"}
                labelClasses={"!text-xs !text-slate-600"}
                {...formValidate(errors, "firstName")}
              />
            </div>

            <div>
              <Input
                label={"Last Name"}
                inputType={"text"}
                value={values?.lastName || ""}
                inputPlaceholder={"Enter last name"}
                inputName="lastName"
                required={true}
                onChange={handleChange}
                isValidate={true}
                charLimit={20}
                inputClasses={"!h-11 md:!h-11"}
                labelClasses={"!text-xs !text-slate-600"}
                {...formValidate(errors, "lastName")}
              />
            </div>

            <div>
              <Input
                label={"Email"}
                inputType={"email"}
                value={values?.email || ""}
                inputPlaceholder={"Enter email"}
                inputName="email"
                onChange={handleChange}
                isValidate={true}
                inputClasses={"!h-11 md:!h-11"}
                labelClasses={"!text-xs !text-slate-600"}
                {...formValidate(errors, "email")}
                isDisabled={true}
                required={true}
              />
            </div>

            <div>
              <PhoneNumberFormat
                label="Phone"
                value={phone || ""}
                isInputGroup={true}
                inputGroupIcon={"fa-solid fa-phone"}
                inputGroupPosition={"left"}
                setPhone={setPhone}
                inputPlaceholder={"(xxx) xxx-xxxx"}
                charLimit={12}
                inputClasses={"!h-11 md:!h-11"}
                labelClasses={"!text-xs !text-slate-600"}
                required={true}
              />
            </div>
            <div>
              <Input
                label={"Address"}
                inputType={"text"}
                value={values?.address || ""}
                inputPlaceholder={"Enter your address"}
                inputName="address"
                onChange={handleChange}
                isValidate={true}
                charLimit={20}
                inputClasses={"!h-11 md:!h-11"}
                labelClasses={"!text-xs !text-slate-600"}
                {...formValidate(errors, "address")}
              />
            </div>
            <div>
              <Input
                label={"Dob"}
                inputType={"date"}
                value={values?.dateOfBirth || ""}
                inputPlaceholder={"Enter dob"}
                inputName="dateOfBirth"
                onChange={handleChange}
                //   onChange={(e) => console.log("val", e.target.value)}
                isValidate={true}
                charLimit={20}
                inputClasses={"!h-11 md:!h-11"}
                labelClasses={"!text-xs !text-slate-600"}
                {...formValidate(errors, "dateOfBirth")}
              />
            </div>
          </div>

          <div className="flex justify-end items-baseline">
            <Button
              buttonType={"submit"}
              buttonIcon={"fa-light fa-floppy-disk"}
              buttonIconPosition={"left"}
              buttonLabel="Save"
              loading={profileLoding}
              isDisable={profileLoding}
              buttonLabelClasses={"!text-sm"}
              buttonClasses="!py-2 !px-2 rounded-lg text-white !h-auto !bg-chestnut-rose hover:!bg-red-600"
            />
            <Tooltip
              id="edit-profile"
              className="!text-slate-500 !text-sm !bg-slate-950 !bg-opacity-100 z-100"
              render={() => (
                <div className="text-white">Click to save profile details.</div>
              )}
            />
          </div>
        </form>
      </div>
    </div>
  );
}

export default ProfileComponent;
